import * as React from "react";

export const IconBlock = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props} >
    <g clipPath="url(#clip0_3661_26287)">
      <path d="M9.99935 1.66602C5.39935 1.66602 1.66602 5.39935 1.66602 9.99935C1.66602 14.5993 5.39935 18.3327 9.99935 18.3327C14.5993 18.3327 18.3327 14.5993 18.3327 9.99935C18.3327 5.39935 14.5993 1.66602 9.99935 1.66602ZM3.33268 9.99935C3.33268 6.31602 6.31602 3.33268 9.99935 3.33268C11.541 3.33268 12.9577 3.85768 14.0827 4.74102L4.74102 14.0827C3.85768 12.9577 3.33268 11.541 3.33268 9.99935ZM9.99935 16.666C8.45768 16.666 7.04102 16.141 5.91602 15.2577L15.2577 5.91602C16.141 7.04102 16.666 8.45768 16.666 9.99935C16.666 13.6827 13.6827 16.666 9.99935 16.666Z" fill="currentColor"/>
    </g>
    <defs>
      <clipPath id="clip0_3661_26287">
        <rect width="20" height="20" fill="white"/>
      </clipPath>
    </defs>
  </svg>

);
